const villa_sec1_part2Object = payload => {
  return {
    type: "villasec1part2",
    payload
  };
};

export default villa_sec1_part2Object;
